import imgCaelus81 from "./img-caelus8 (1).webp";
import imgCaelus82 from "./img-caelus8 (2).webp";
import imgCaelus83 from "./img-caelus8 (3).webp";
import imgCaelus84 from "./img-caelus8 (4).webp";

const imgCaelus8 = [imgCaelus81, imgCaelus82, imgCaelus83, imgCaelus84];

export default imgCaelus8;
